export const profileReportUtils = {
  svgToPng: async (
    svgEl: SVGSVGElement,
    opts: { scale?: number; backgroundColor?: string } = {},
  ): Promise<HTMLCanvasElement> => {
    const { scale = 2, backgroundColor } = opts;

    // 1) Figure out logical size
    const vb = svgEl.viewBox?.baseVal;
    const logicalW = Math.max(1, Math.floor(vb?.width || svgEl.clientWidth || 1000));
    const logicalH = Math.max(1, Math.floor(vb?.height || svgEl.clientHeight || 600));

    // 2) Target pixel size (device ratio × your scale)
    const ratio = (window.devicePixelRatio || 1) * scale;
    const pxW = Math.round(logicalW * ratio);
    const pxH = Math.round(logicalH * ratio);

    // 3) Clone the SVG and enforce pixel width/height (keep styles!)
    const clone = svgEl.cloneNode(true) as SVGSVGElement;
    if (!clone.getAttribute('xmlns')) {
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    }
    if (!clone.getAttribute('xmlns:xlink')) {
      clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    }
    if (!clone.getAttribute('viewBox')) {
      clone.setAttribute('viewBox', `0 0 ${logicalW} ${logicalH}`);
    }
    // IMPORTANT: do not strip clone.style or style attribute
    clone.setAttribute('width', String(pxW));
    clone.setAttribute('height', String(pxH));

    const svgString = new XMLSerializer().serializeToString(clone);

    // 4) Load into an <img> (wait for onload)
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.crossOrigin = 'anonymous';

    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = (e) => reject(e);
      img.src = url;
    });

    // 5) Paint on a 1:1 canvas
    const canvas = document.createElement('canvas');
    canvas.width = pxW;
    canvas.height = pxH;
    const ctx = canvas.getContext('2d')!;

    if (backgroundColor) {
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(0, 0, pxW, pxH);
    }

    ctx.drawImage(img, 0, 0);
    URL.revokeObjectURL(url);
    return canvas;
  },
};
